import InfraFacilityManagementView from '@/domains/asset-management/components/InfraFacilityManagementView';

const InfraManagement = () => (
  <InfraFacilityManagementView
    infraAndFacilityType="INFRA_TP_INFRA"
    breadcrumbLabel="ASSET-INFRA"
    typeColumnTitle="infra > type"
    nameColumnTitle="infra > name"
    typeFieldLabel="infra > type"
    nameFieldLabel="infra > name"
    searchPlaceholder="infra > search by name"
  />
);

export default InfraManagement;
